(function () {
	function swiperInit() {
		// console.log("Initializing Swiper...");
		
		if (typeof reinitSlider === 'function') {
			reinitSlider();
		} else {
			// Fallback if reinitSlider is not defined
			if (typeof subSliderInit === 'function') subSliderInit(true);
			if (typeof sliderInit === 'function') sliderInit(true);
		}
		
		if (typeof popupSliderInit === 'function') popupSliderInit(true);

		// Force height update after a short delay
		setTimeout(() => {
			if (typeof forceUpdateSwiperHeight === 'function') forceUpdateSwiperHeight();
		}, 500);
	}


	function tryInit(attempts = 0) {
		if (typeof sliderInit === 'function' && typeof Swiper !== 'undefined') {
			swiperInit();
		} else if (attempts < 50) {
			setTimeout(() => tryInit(attempts + 1), 100);
		}
	}

	// Handle Shopify section load
	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	// Initial load
	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		tryInit();
	} else {
		document.addEventListener('DOMContentLoaded', () => tryInit());
	}

	// Backup initialization on window load
	window.addEventListener('load', () => swiperInit());

	window.isSwiperInit = true;
})();

